import { Checkbox } from "semantic-ui-react";
import { ConfirmBoxOptionsType } from "../../reducer/type";
import { Dispatch, SetStateAction } from "react";

type RebootTypeProps = {
  options: ConfirmBoxOptionsType;
  setOptions: Dispatch<SetStateAction<ConfirmBoxOptionsType>>;
};
const RebootType = ({ options, setOptions }: RebootTypeProps) => {
  const onChange = () => {
    setOptions((prevOptions) => ({
      ...prevOptions,
      reboot: options.reboot === "soft" ? "hard" : "soft",
    }));
  };
  return (
    <Checkbox
      className="color-gray simple-checkbox margin-top margin-right-20"
      label="Perform a Hard reboot"
      checked={options.reboot === "hard"}
      onChange={onChange}
    />
  );
};

export default RebootType;
